"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapSiteAggregationRegionsToCommonAggregationRegions = exports.mapSiteRegiontoCommonRegion = exports.getSiteReviewDetails = exports.getPropertyImages = exports.getPropertyUsps = void 0;
const site_search_service_helper_1 = require("../site-search-service.helper");
const getPropertyUsps = (code, summariesResult) => {
    return ((summariesResult?.summaries?.find((summary) => summary.code === code) || {
        usps: [],
    }).usps || [])?.slice(0, site_search_service_helper_1.NUM_OF_USP_TO_SHOW); // TODO: remove as soon as can apply limit at API level
};
exports.getPropertyUsps = getPropertyUsps;
const getPropertyImages = (code, summariesResult) => {
    const images = (summariesResult?.summaries?.find((summary) => summary.code === code) || {
        images: [],
    })?.images || null;
    if (images) {
        return images;
    }
    const image = summariesResult?.summaries?.find((summary) => summary.code === code)
        ?.image || null;
    if (image !== null) {
        return [image];
    }
    return [];
};
exports.getPropertyImages = getPropertyImages;
const getSiteReviewDetails = (code, summariesResult) => {
    return (summariesResult.summaries.find((summary) => summary.code === code) || {
        review: {},
    }).review;
};
exports.getSiteReviewDetails = getSiteReviewDetails;
const mapSiteRegiontoCommonRegion = (region) => {
    return {
        region: region.regionName,
        count: region.count,
        id: region.regionCode,
    };
};
exports.mapSiteRegiontoCommonRegion = mapSiteRegiontoCommonRegion;
const mapSiteAggregationRegionsToCommonAggregationRegions = (regions) => {
    const mappedRhsLevels = Object.keys(regions).map((rhsLevel) => {
        return regions[rhsLevel].map((region) => (0, exports.mapSiteRegiontoCommonRegion)(region));
    });
    return {
        rhs1: mappedRhsLevels[0],
        rhs2: mappedRhsLevels[1],
        rhs3: mappedRhsLevels[2],
        rhs4: mappedRhsLevels[3],
        rhs5: mappedRhsLevels[4],
    };
};
exports.mapSiteAggregationRegionsToCommonAggregationRegions = mapSiteAggregationRegionsToCommonAggregationRegions;
//# sourceMappingURL=utils.js.map